import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { TopBar } from '../topBar';
import { authActions } from '../../store';
import { connectSocket, disconnectSocket } from '../../utils/socketManager';
import { useSocketEvents } from '../../utils/useSocketEvents';

export const Layout = ({ children }) => {
  const dispatch = useDispatch();

  useSocketEvents();

  useEffect(() => {
    dispatch(authActions.getMyProfile());
    connectSocket();
    return () => disconnectSocket();
  }, [dispatch]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <TopBar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          mt: '64px',
          bgcolor: 'background.default',
          overflow: 'auto',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
